<template>
  <div
    class="rounded-extra-small cursor-pointer p-4 transition-all"
    :class="[
      isSelected && 'bg-secondary-container border-secondary rounded-large! border',
      !isSelected && 'border-surface-container bg-surface-container border',
    ]"
  >
    <h4
      class="text-body-large mb-2 transition-all"
      :class="[isSelected && 'text-on-secondary-container font-medium']"
    >
      {{ question.content }}
    </h4>
    <PerspectiveValueBarNew
      :values="perspectiveBarEntries"
      :all-perspectives="topicPerspectives"
      :scale="scale"
    />
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import type { Perspective } from '@/core/models/perspective'
  import { toValueBarPerspectives } from '@/core/models/perspective-analysis'
  import type { ScoredPerspectiveAnalysis } from '@/core/models/surveys-analytics'
  import PerspectiveValueBarNew from '@/core/components/analytics/question-list/PerspectiveValueBarNew.vue'

  interface Props {
    question: {
      readonly questionId: string
      readonly content: string
      readonly perspectives: ReadonlyArray<ScoredPerspectiveAnalysis>
    }
    topicPerspectives: ReadonlyArray<Perspective>
    isSelected: boolean
    scale: ReadonlyArray<{ value: number; label: string }>
  }

  const props = defineProps<Props>()

  const perspectiveBarEntries = computed(() =>
    toValueBarPerspectives(props.question.perspectives, props.topicPerspectives),
  )
</script>
